import * as React from "react";
import { EventContact } from "src/api/events/event.types";

interface EventContactSectionProps {
  title: string;
  contacts: EventContact[];
}

const EventContactSection: React.FC<EventContactSectionProps> = ({ title, contacts }) => (
  <div className="d-flex flex-column">
    <span className="fs-14 fw-medium">{title}</span>
    <span className="text-secondary border-bottom my-2 border-opacity-40" />
    {contacts.map((contact, idx) => (
      <div key={contact.id || idx} className="d-flex flex-column align-items-start gap-2">
        <span className="fs-14 fw-regular ">{contact.friendlyName}</span>
        {contact.businessPhone && (
          <div className="d-flex gap-1 align-items-center">
            <span className="fs-14 fw-regular ">Tel.</span>
            <a className="fs-14 fw-regular text-secondary" href={`tel:${contact.businessPhone}`}>
              {contact.businessPhone}
            </a>
          </div>
        )}
        {contact.mobilePhone && (
          <div className="d-flex gap-1 align-items-center">
            <span className="fs-14 fw-regular ">Mob.</span>
            <a className="fs-14 fw-regular text-secondary" href={`tel:${contact.mobilePhone}`}>
              {contact.mobilePhone}
            </a>
          </div>
        )}
      </div>
    ))}
  </div>
);

export default EventContactSection;
